"use client";
import React, { useState } from "react";
import {
    Box,
    Button,
    Tabs,
    Tab,
    Checkbox,
    FormControlLabel,
    Typography,
} from "@mui/material";

// -------------------- Component --------------------
function FilterOutletPopup() {
    const [selectedTab, setSelectedTab] = useState(0);

    // Static mock data
    const mockLocations = ["Delhi", "Mumbai", "Bangalore", "Patna"];
    const mockPointsTransactions = ["Credited", "Debited", "Expired", "Expiring"];
    const mockRedemptionRequests = ["Rejected", "Approved"];

    // Tabs config
    const tabsConfig = [
        { label: "Location", items: mockLocations },
        { label: "Points Transaction", items: mockPointsTransactions },
        { label: "Redemption Request", items: mockRedemptionRequests },
    ];

    // Tab change handler
    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
    };

    return (
        <Box
            sx={{
                position: "absolute",
                width: "400px",
                right: "3%",
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                zIndex: 9999,
            }}
        >
            {/* Tabs */}
            <Box sx={{ width: "100%", display: "flex" }}>
                <Box sx={{ width: "200px", borderRight: "1px solid #ddd" }}>
                    <Tabs
                        orientation="vertical"
                        value={selectedTab}
                        onChange={handleTabChange}
                        aria-label="Filter tabs"
                    >
                        {tabsConfig.map((tab, index) => (
                            <Tab key={index} label={tab.label} sx={tabStyles} />
                        ))}
                    </Tabs>
                </Box>

                {/* Filters */}
                <Box sx={{ paddingLeft: "20px", flexGrow: 1 }}>
                    {tabsConfig.map((tab, index) =>
                        selectedTab === index ? (
                            <Box key={index} sx={{ marginBottom: "16px" }}>
                                <FormControlLabel
                                    control={<Checkbox />}
                                    label="Select All"
                                />
                                {tab.items.map((item) => (
                                    <FormControlLabel
                                        key={item}
                                        sx={{ display: "block" }}
                                        control={<Checkbox />}
                                        label={item}
                                    />
                                ))}
                            </Box>
                        ) : null
                    )}
                </Box>
            </Box>

            {/* Buttons */}
            <Box
                sx={{
                    marginTop: "1rem",
                    width: "100%",
                    justifyContent: "end",
                    display: "flex",
                    borderTop: "1px solid #ddd",
                    pt: 1,
                }}
            >
                <Button sx={clearButtonStyles}>Clear All</Button>
                <Button sx={applyButtonStyles}>Apply</Button>
            </Box>

            {/* Dummy Results */}
            <Box sx={{ marginTop: "20px" }}>
                <Typography variant="body2" color="text.secondary">
                    (Results UI here…)
                </Typography>
            </Box>
        </Box>
    );
}

// -------------------- Styles --------------------
const tabStyles = {
    whiteSpace: "nowrap",
    fontSize: "14px",
    color: "#282829",
    fontWeight: "500",
    textTransform: "capitalize",
    alignItems: "start",
    "&:hover": { backgroundColor: "#F9FBFC" },
    "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
};

const clearButtonStyles = {
    border: "1px solid #E7E8E9",
    color: "#000",
    marginRight: "10px",
};
const applyButtonStyles = { border: "1px solid #C8172F", color: "#C8172F" };

export default FilterOutletPopup;
